import { propEq } from 'ramda'
import React from 'react'

import { getQueryParam } from '../../../utils/helpers/url'
import { useNavigation } from '../../../utils/contexts/NavigationContext'
import DropdownLink from '../../../components/navigation/DropdownLink'
import IconButton from '../../../components/actions/IconButton'

const ViewsDropdown = ({ active }) => {
  const origin = getQueryParam('origin') || 'serviceOrder'
  const navigate = useNavigation()
  const options = [
    {
      label: 'Visão de ocorrências',
      value: 'list',
      iconLeft: 'BsListTask',
      onClick: () => navigate(`/non-compliances?origin=${origin}`)
    },
    {
      label: 'Visão agrupada por local',
      value: 'placeList',
      iconLeft: 'BsListNested',
      onClick: () => navigate(`/place-non-compliances?origin=${origin}`)
    }
  ]

  const selectedOption = options.find(propEq('value', active || 'list'))

  return (
    <DropdownLink
      actionContent={<IconButton iconLeft={selectedOption.iconLeft} label={selectedOption.label} transparent noWrap />}
      options={options}
    />
  )
}

export default ViewsDropdown
